// extracted by mini-css-extract-plugin
export const root = "back-button-module--root--2HLY9";